/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';

import makeFormReadOnly from '@/util/makeFormReadOnly';

import tmplMFDDeviceEditModalView from './MFDDeviceEditModalView.hbs';

const MFDDeviceEditModalView = View.extend({
  template: tmplMFDDeviceEditModalView,

  className: 'mfd-device-edit-modal-view',

  ui: {
    submit: '.btn-submit',
    cancel: '.btn-cancel'
  },

  events: {
    'click @ui.submit': 'onClickSubmit',
    'click @ui.cancel': 'onClickCancel'
  },

  onRender() {
    const model = this.model.get('device');
    Syphon.deserialize(this, model);
    if (this.model.get('isReadOnly')) {
      makeFormReadOnly(this.$el);
    }
  },

  onClickSubmit(e) {
    e.preventDefault();
    const formData = Syphon.serialize(this);
    //call edit service here
    this.triggerMethod('modal:close', formData);
  },

  onClickCancel(e) {
    e.preventDefault();
    this.triggerMethod('modal:close');
  }
});

export default MFDDeviceEditModalView;
